import getBG from '../../utils/utils';

export default {
    name: 'corporate-culture-detail',
    data() {
        return {
            backgroundImage: '',
            content: '',
            pageNum: 1,
            pageCount: 10
        };
    },
    created() {
        this.init();
        this.getContext();
    },
    mounted() {},
    methods: {
        async init() {
            this.backgroundImage = await getBG.call(this, 'AboutWanxun');
        },
        // 查询富文本信息
        getContext() {
            this.$http
                .fetchData('contentManage/getContentManageList', {
                    id: this.$route.query.id
                })
                .then(res => {
                    console.log(res);
                    this.content = res[0].content;
                })
                .catch(err => {
                    this.$message({
                        message: err,
                        type: 'error'
                    });
                });
        }
    }
};
